import axios, {AxiosResponse} from 'axios'
import {ID, Response} from '../../../../../_metronic/helpers'
import {User, UsersQueryResponse} from './_models'

const API_URL = process.env.REACT_APP_THEME_API_URL
const USER_URL = `${API_URL}/user`
const GET_Inquiry_USERS_URL = `${API_URL}/inquiry_user`

const getUsers = (query: string): Promise<UsersQueryResponse> => {
  return axios
    .get(`${USER_URL}?${query}`)
    .then((d: AxiosResponse<UsersQueryResponse>) => d.data)
}

const fileCheck = (query: string) => {
  return axios
    .get(`${API_URL}/check-file/${query}`)
    .then((d) => d.data)
}

const getInquiryUsers = (query: string): Promise<UsersQueryResponse> => {
  return axios
    .get(`${GET_Inquiry_USERS_URL}?${query}`)
    .then((d: AxiosResponse<UsersQueryResponse>) => d.data)
}

const getUserById = (id: ID): Promise<User | undefined> => {
  return axios
    .get(`${USER_URL}/${id}`)
    .then((response: AxiosResponse<Response<User>>) => response.data)
    .then((response: Response<User>) => response.data)
}

const createUser = (user: FormData): Promise<UsersQueryResponse | undefined> => {
  return axios
    .post(USER_URL, user)
    .then((response: AxiosResponse<UsersQueryResponse>) => response.data)
    .then((response: UsersQueryResponse) => response)
}

const updateUser = (user: FormData,id:ID): Promise<UsersQueryResponse | undefined> => {
  return axios
    .post(`${USER_URL}/${id}`, user,{headers:{"Content-Type":"multipart/form-data"}})
    .then((response: AxiosResponse<UsersQueryResponse>) => response.data)
    .then((response: UsersQueryResponse) => response)
}

const updateProfile = (user: FormData,id:ID): Promise<UsersQueryResponse | undefined> => {
  return axios
    .post(`${API_URL}/profileupdate/${id}`, user,{headers:{"Content-Type":"multipart/form-data"}})
    .then((response: AxiosResponse<UsersQueryResponse>) => response.data)
    .then((response: UsersQueryResponse) => response)
}

const changePassword = (user: FormData): Promise<UsersQueryResponse | undefined> => {
  return axios
    .post(`${API_URL}/changepassword`, user,{headers:{"Content-Type":"multipart/form-data"}})
    .then((response: AxiosResponse<UsersQueryResponse>) => response.data)
    .then((response: UsersQueryResponse) => response)
}

const resetPassword = (user: FormData): Promise<UsersQueryResponse | undefined> => {
  return axios
    .post(`${API_URL}/resetpassword`, user,{headers:{"Content-Type":"multipart/form-data"}})
    .then((response: AxiosResponse<UsersQueryResponse>) => response.data)
    .then((response: UsersQueryResponse) => response)
}

const getDbExport = (query: string): Promise<UsersQueryResponse> => {
  return axios
    .get(`${API_URL}/export_db`)
    .then((d: AxiosResponse<UsersQueryResponse>) => d.data)
}


const deleteUser = (userId: ID): Promise<UsersQueryResponse | undefined> => {
  return axios
  .delete(`${USER_URL}/${userId}`)
  .then((response: AxiosResponse<UsersQueryResponse>) => response.data)
  .then((response: UsersQueryResponse) => response)
}

const deleteSelectedUsers = (userIds: Array<ID>): Promise<void> => {
  const requests = userIds.map((id) => axios.delete(`${USER_URL}/${id}`))
  return axios.all(requests).then(() => {})
}

export {getUsers, deleteUser, deleteSelectedUsers, getUserById, createUser, updateUser,getInquiryUsers,fileCheck,updateProfile,changePassword,resetPassword,getDbExport}
